"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CSPreferenceCenterComponent = void 0;
const accountsettings_service_1 = require("./../../services/accountsettings.service");
const helper_service_1 = require("./../../services/helper.service");
const _ = require("underscore");
const generic_content_service_1 = require("../../services/generic.content.service");
class CSPreferenceCenterComponent {
    constructor(helperService, accountDetailService, genericContentService) {
        this.helperService = helperService;
        this.accountDetailService = accountDetailService;
        this.genericContentService = genericContentService;
        this.showContent = [];
        this.sortFilterArray = ['1-10', '20 lines', '50 lines', '100 lines'];
        this.selectedSortNumber = '1-10';
        this.pager = {};
    }
    ngOnInit() {
        this.paginationSize = -1;
        this.getAccountInformationDetails();
        this.getGenericPreferenceErrorMessage();
        if (window.screen.width <= 768) {
            this.textShow = true;
        }
    }
    getAccountInformationDetails() {
        this.loader = true;
        this.accountDetailService.getPreferenceCenterInformation().subscribe((info) => {
            this.loader = false;
            this.areEmailsToggled = false;
            this.areTextsToggled = false;
            this.preferenceInfo = _.sortBy(info, 'mobileNumber');
            this.updateAllPreferenceToggles(info);
            this.selectedSortNumber = '1-10';
            this.onSelectSort(this.selectedSortNumber);
        }, (err) => {
            this.error = err;
            this.loader = false;
        });
    }
    setPage(page, pageSize) {
        if (this.pager.totalPages !== 0) {
            if (page < 1 || page > this.pager.totalPages) {
                return;
            }
        }
        if (pageSize === '1-10') {
            pageSize = 10;
        }
        else if (pageSize === '20 lines') {
            pageSize = 20;
        }
        else if (pageSize === '50 lines') {
            pageSize = 50;
        }
        else if (pageSize === '100 lines') {
            pageSize = 100;
        }
        // get pager object from service
        if (this.preferenceInfo !== null && this.preferenceInfo !== undefined
            && page !== undefined) {
            this.pager = this.helperService.getPager(this.preferenceInfo.length, page, pageSize);
            this.startIndex = this.pager.startIndex;
            this.endIndex = this.pager.endIndex + 1;
        }
    }
    onSelectSort(selectNumber) {
        this.setPage(1, selectNumber);
        if (selectNumber === '1-10') {
            this.sortNumber = 10;
        }
        else if (selectNumber === '20 lines') {
            this.sortNumber = 20;
        }
        else if (selectNumber === '50 lines') {
            this.sortNumber = 50;
        }
        else if (selectNumber === '100 lines') {
            this.sortNumber = 100;
        }
        this.setPage(this.pager.currentPage, this.sortNumber);
    }
    toggleEmailButton(preferenceInfo) {
        if (!this.areEmailsToggled) {
            this.loader = true;
            preferenceInfo.preference.promotion_emails = !preferenceInfo.preference.promotion_emails;
            this.updateAllPreferenceToggles(this.preferenceInfo);
            this.accountDetailService.submitIndividualPreferences(preferenceInfo.subscriptionId, preferenceInfo.preference.promotion_emails, preferenceInfo.preference.promotion_texts).subscribe((data) => {
                this.loader = false;
            }, (err) => {
                this.error = err;
                this.loader = false;
            });
        }
    }
    toggleTextButton(preferenceInfo) {
        if (!this.areTextsToggled) {
            this.loader = true;
            preferenceInfo.preference.promotion_texts = !preferenceInfo.preference.promotion_texts;
            this.updateAllPreferenceToggles(this.preferenceInfo);
            this.accountDetailService.submitIndividualPreferences(preferenceInfo.subscriptionId, preferenceInfo.preference.promotion_emails, preferenceInfo.preference.promotion_texts).subscribe((data) => {
                this.loader = false;
            }, (err) => {
                this.error = err;
                this.loader = false;
            });
        }
    }
    updateAllPreferenceToggles(info) {
        let initialEmailsActive = true;
        let initialTextsActive = true;
        let hideSection = false;
        info.forEach(function (individualPreference) {
            if (individualPreference.preference) {
                if (individualPreference.preference.promotion_emails === false) {
                    initialEmailsActive = false;
                }
                if (individualPreference.preference.promotion_texts === false) {
                    initialTextsActive = false;
                }
            }
            else {
                hideSection = true;
            }
        });
        this.hideSection = hideSection;
        this.allEmails = initialEmailsActive;
        this.allTexts = initialTextsActive;
    }
    toggleAllTextButton() {
        this.allTexts = !this.allTexts;
        this.areTextsToggled = true;
        const allTexts = this.allTexts;
        this.preferenceInfo.forEach(function (individualPreference) {
            individualPreference.preference.promotion_texts = allTexts;
        });
        this.loader = true;
        this.accountDetailService.submitAllTextsPreferences(this.allTexts).subscribe((data) => {
            this.areTextsToggled = false;
            this.loader = false;
        }, (err) => {
            this.error = err;
            this.loader = false;
        });
    }
    toggleAllEmailButton() {
        this.allEmails = !this.allEmails;
        this.areEmailsToggled = true;
        const allEmails = this.allEmails;
        this.preferenceInfo.forEach(function (individualPreference) {
            individualPreference.preference.promotion_emails = allEmails;
        });
        this.loader = true;
        this.accountDetailService.submitAllEmailsPreferences(this.allEmails).subscribe((data) => {
            this.areEmailsToggled = false;
            this.loader = false;
        }, (err) => {
            this.error = err;
            this.loader = false;
        });
    }
    getGenericPreferenceErrorMessage() {
        this.genericContentService.getGenericContent('genericNullPreferenceErrorMessage').subscribe((data) => {
            this.genericPreferenceErrorMsg = data;
        }, (err) => {
            this.error = err;
        });
    }
}
exports.CSPreferenceCenterComponent = CSPreferenceCenterComponent;
//# sourceMappingURL=preferencecenter.component.js.map